'use client';

import { IconSearch, IconCancel } from '@/components/icons';
import { useState, useEffect } from 'react';

type Props = {
  isActive?: boolean;
  className?: string;
  cancelIcon?: boolean;
  setIsSearching?: React.Dispatch<React.SetStateAction<boolean>>;
  value?: string;
  onChange?: (value: string) => void;
};

const Search = ({
  isActive,
  className,
  cancelIcon = true,
  setIsSearching,
  value,
  onChange,
}: Props) => {
  const [isClick, setIsClick] = useState(isActive);
  const [innerValue, setInnerValue] = useState(value ?? '');

  // 當外部 value 改變時，同步進來（只為了顯示用）
  useEffect(() => {
    if (value !== undefined) {
      setInnerValue(value);
    }
  }, [value]);

  const actualValue = value !== undefined ? value : innerValue;

  useEffect(() => {
    setIsSearching?.(actualValue !== '');
  }, [actualValue, setIsSearching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    // 有給 onChange 就交給父層
    onChange?.(v);
    // 若父層沒控制，就自己存
    if (value === undefined) {
      setInnerValue(v);
    }
  };

  const handleClear = () => {
    onChange?.('');
    if (value === undefined) {
      setInnerValue('');
    }
    setIsClick(false);
  };

  return (
    <>
      {isClick ? (
        <div className="position-relative">
          <input
            type="text"
            name="search"
            id="search"
            placeholder="我要找..."
            className={`ps-6 fw-bold  ${className}`}
            value={actualValue}
            onChange={handleChange}
          />
          {cancelIcon && (
            <button
              type="button"
              className="line-height-none position-absolute top-50 end-0 translate-middle"
              onClick={handleClear}
            >
              <IconCancel width={16} color="#757575" />
            </button>
          )}

          {!actualValue && (
            <span className="line-height-none position-absolute top-50 start-0 translate-middle ms-3 text-muted">
              <IconSearch width={14} />
            </span>
          )}
        </div>
      ) : (
        <button type="button" className="line-height-none" onClick={() => setIsClick(true)}>
          <IconSearch width={23} />
        </button>
      )}
    </>
  );
};

export default Search;
